<template>
	<div class="appr-container m-0 p-0" style="background-color: #000000;">
		<div class="container-fluid my-0" v-if="(isMobile && !isPortrait) || !isMobile">
			<div class="row justify-content-center m-0" v-if="game">
				<div id="full-video-container" class="col-lg-10 position-relative m-0">
					<div class="inner-vid-conteiner m-0 w-100">
						<div class="inner-vid-wrap m-0 w-100" :style="{'backgroundImage': 'url(' + cover + ')' }">
							<div class="vid-vrapper w-100 h-100 position-relative">

								<transition name="fade">
									<div class="row align-items-center justify-content-center h-100" v-if="step == 1">
										<div class="col-lg-10 text-center" style="margin-top: -30px">
											<div class="border-4-blk-new bg-white p-2-pr text-center mx-3">
												<p class="m-0 ultra-bold text-size-box-4 text-2">
													E-cig e riscaldatori di tabacco: le ultime novità della grande famiglia del fumo.<br>
													<span class="text-orange">Ma fanno davvero meno male</span>? O è solo un modo più profumato, colorato e alla moda di fumare la vecchia e cara sigaretta?
												</p>
											</div>
											<p class="ultra-bold text-color-default text-size-box-5 text-1" style="margin-top: 1.5%">
												Scopri quanto ne sai<br>
												su sigarette elettroniche<br>
												e riscaldatori di tabacco!
											</p>
										</div>
									</div>
								</transition>

								<!-- Step 2 ********************* -->
								<transition name="fade">
									<div class="row align-items-start justify-content-center h-100" v-if="step == 2">
										<div class="col-12 text-center h-100">

											<div class="row mx-0 h-100">
												<div class="col-7">
													<div class="py-answers-box text-color-default question-container">
														<div class="row">
															<div class="col-12 text-center text-size-box-3 ultra-bold mt counter">
																{{this.question}} di 10
															</div>
															<div class="col-12 text-center">
																<h2 class="text-size-box-4 mb-0">{{questionsObj.arg}}</h2>
															</div>
															<div class="col-12 py-0 px-5">
																<img :src="separatrPointsUrl" alt="sep" class="img-fluid w-100">
															</div>
															<div class="col-12 text-center">
																<h2 class="text-size-box-4 lh-1-05" v-html="questionsObj.question"></h2>
															</div>

															<div class="col-12 text-left mt-answers">
																<div v-for="(answer, index) in questionsObj.answers"
																	:key="index"
																	class="d-flex flex-row flex-nowrap align-items-center justify-content-between my-button btn rounded-pill text-white"
																	:class="{'bg-orange-1': (answer.label === 'A'), 'bg-green-1': (answer.label === 'B'), 'bg-blue-1': (answer.label === 'C'), 'bg-dark-blue-1': (answer.label === 'D'), [answer.label]: true}"
																	@click="checkAnswer(answer.label)"
																>

																	<div class="label-answer ultra-bold text-white text-center">
																		<div class="va-text-bottom label-answer-inner ">
																			<span class="va-m text-size-box-9">{{answer.label}}</span>
																		</div>
																	</div>

																	<div class="text-center w-100">
																		<div class="text-size-box-9 lh-1-05" v-html="answer.risposta"></div>
																	</div>

																</div>
															</div>

														</div>
													</div>
												</div>

												<!-- output box -->
												<div class="col-5 align-self-top mt-answers align-self-center">
													<transition name="fade">
														<div class="border-4-blk-new bg-white p-3 text-left mx-epilogo" v-if="showResponse">
															<h2 class="text-size-box-4 ultra-bold text-orange" v-html="responseTitle"></h2>
															<p class="m-0 text-size-box-6 text-2" v-html="responseText"></p>
														</div>
													</transition>
													<transition name="fade">
														<div class="text-center mt-btn-epilog" v-if="showResponse">
															<button class="btn btn-blk rounded-pill px-5" @click.prevent="nextQuestion"><span class="va-m">AVANTI</span></button>
														</div>
													</transition>
												</div>
											</div>

										</div>
									</div>
								</transition>

								<!-- Step 3 - END-->
								<transition name="fade">
									<div class="row align-items-center justify-content-center h-100" v-if="step == 3">
										<div class="col-lg-10 text-center">
											<div class="border-4-blk-new bg-white p-3 text-center mx-3">
												<p class="m-0 ultra-bold text-size-box-4 text-2">
												Hai notato quanta <span class="text-orange">confusione</span> c’è nel mondo<br>
												del ‘nuovo fumo’?<br>
												Sentiamo spesso messaggi rassicuranti su sigarette elettroniche e riscaldatori di tabacco ma in realtà gli effetti sulla salute sono ancora in fase di valutazione.<br>
												<span class="text-orange">Questi strumenti, però, possono avvicinare al<br>‘mondo del fumo’<br>
												e delle sigarette classiche!</span>
												</p>
											</div>
										</div>

										<div id="btn-go" class="text-center col-12">
												<button class="btn btn-blk approf game rounded-pill px-5" @click.prevent="nextStep">AVANTI</button>
										</div>
									</div>
								</transition>

								<div class="btn-cmd text-center my-2x" v-if="step == 1">
									<button class="btn btn-blk rounded-pill px-5 py-btn" @click.prevent="nextStep" :disabled="btnDisabled"><span class="va-m">{{btnText}}</span></button>
								</div>


								<transition name="fade">
									<div class="d-flex w-100 h-100 align-items-center justify-content-center video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 4">
										<div class="row px-4 h-100 align-items-center">

											<div class="col-12 align-self-end">
												<p class="text-color-default ultra-bold text-center text-size-box-10 end mb-0 full-text">
													Ora continua il tuo viaggio!<br>
													Scopri cosa c’è davvero dentro una sigaretta elettronica e un riscaldatore di tabacco.
												</p>
											</div>

											<div class="col-12 text-center">
												<a :href="linkUrl.back" class="btn btn-blk approf rounded-pill mr-3 go-next-back mb-2"><span class="va-m">TORNA INDIETRO</span></a>
												<a :href="linkUrl.next" class="btn btn-blk approf rounded-pill go-next-back mb-2"><span class="va-m">VAI AL PROSSIMO PERCORSO</span></a>
											</div>

										</div>
									</div>
								</transition>

							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div id="mobile-icon-container" class="container-fluid" v-else>
			<div class="row">
				<div class="col-12">
					<div class="img-rotate position-relative" style="height: 100vh;">
						<img id="phone-gif" :src="rotateScreenUrl" alt="Rotate phone">
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
const jQuery = window.jQuery
import { urlBase, themeDir, urlHost } from '../../variables.js'
import axios from 'axios'

export default {
	name: 'AOgniCostoComponent',

	data() {
		return {
			ajaxObj: window.ajax_object,
			isMobile: false,
			isPortrait: false,
			themeUrl: '',
			rotateScreenUrl: '',
			game: true,
			covers: {
				coverUrl:'',
				coverElettUrl: '',
				coverRiscUrl: ''
			},
			btnText: 'VAI AL QUIZ',
			step: 1,
			question: 1,
			answer: '',
			questionsObj: {
				arg: '',
				question: '',
				answers: {}
			},
			cover: '',
			btnDisabled: false,
			showResponse: false,
			responseText: '',
			responseTitle: '',
			activeCls: '',
			linkUrl: {
				back: '',
				next: ''
			}
		}
	},

	methods: {
		isMobileFn() {
			this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		},
		isPortraitFn() {
			this.isPortrait = (window.innerHeight > window.innerWidth)
		},
		handleOrientationChange() {
			this.isMobileFn()
			this.isPortraitFn()
			if(this.isPortrait) {
				this.isMobile = true
				this.isPortrait = false
				this.removeEvent()
			}
		},
		removeEvent() {
			window.removeEventListener("orientationchange", this.handleOrientationChange, true)
		},

		nextStep() {
			if(this.step == 1) {
				this.step = 2
				this.cover = this.covers.coverElettUrl
				this.getCurrentQuiz()
			} else if(this.step == 2 && this.question > 10) {
				this.step = 3
			} else if(this.step == 3) {
				this.step = this.step + 1
			}
		},
		nextQuestion() {
			jQuery(this.activeCls).removeClass('shake-horizontal')
			this.question = (this.question + 1);
			if(this.question > 5) {this.cover = this.covers.coverRiscUrl}
			if(this.question > 10) {
				this.nextStep()
				this.cover = this.covers.coverUrl
			} else {
				this.getCurrentQuiz()
			}

		},
		getCurrentQuiz() {
			let url = this.ajaxObj.ajax_url

			var data = new FormData();
			data.append('action', 'nl_get_current_quiz')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('question', this.question)

			this.btnDisabled = false

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					this.showResponse = false

					this.questionsObj.arg = response.data.quiz.contesto
					this.questionsObj.question = response.data.quiz.domanda
					this.questionsObj.answers = response.data.answers
				}, (error) => {
					console.log(error);
				});
		},
		checkAnswer(label) {
			if (!this.btnDisabled) {
				this.btnDisabled = true
				let url = this.ajaxObj.ajax_url
				this.answer = label

				var data = new FormData();
				data.append('action', 'nl_check_quiz_answer')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('question', this.question)
				data.append('answer', this.answer)

				axios.post(url, data)
					.then((response) => {
						// console.log(response.data)
						if(response.data.correct != '') {
							this.responseTitle = response.data.quiz.titolo_epilogo_ko
							this.activeCls = '.' + response.data.correct
							jQuery(this.activeCls).addClass('shake-horizontal')
						} else {
							this.responseTitle = response.data.quiz.titolo_epilogo_ok
						}
						this.responseText = response.data.quiz.epilogo

						this.showResponse = true
					}, (error) => {
						console.log(error);
					});
			}
		},
		calculateVideoWidth() {
			let screen_h = screen.availHeight
			let screen_w = ((screen_h * 16) / 9) - 20

			jQuery('#full-video-container').css('max-width', screen_w + 'px')
			jQuery('.pop-up-container').css('max-height', (jQuery('.inner-vid-conteiner').outerHeight() - 30)  + 'px')
			jQuery('.mx-epilogo').css('max-height', (jQuery('.inner-vid-conteiner').outerHeight() - (jQuery('.inner-vid-conteiner').outerHeight() * 24) / 100)  + 'px')
		},
	},

	mounted() {
		let _self = this

		jQuery('#wrapper-navbar, #wrapper-footer').addClass('d-none')

		this.themeUrl = urlBase + themeDir

		this.isMobileFn()
		this.isPortraitFn()
		if(this.isMobile && this.isPortrait) {
			this.rotateScreenUrl = this.themeUrl + 'img/rotate_screen.gif'
			window.addEventListener("orientationchange", this.handleOrientationChange, true)
		}

		jQuery(window).resize(function() {
			_self.calculateVideoWidth()
		})

		this.covers.coverUrl = this.themeUrl + 'img/covers/A_ogni_costo_cover_back.jpg'
		this.covers.coverElettUrl = this.themeUrl + 'img/covers/Fondo_ecig.jpg'
		this.covers.coverRiscUrl = this.themeUrl + 'img/covers/Fondo_riscaldatori.jpg'

		this.cover = this.covers.coverUrl

		this.separatrPointsUrl = this.themeUrl + 'img/riga_pallini.png'

		this.linkUrl.back = urlBase + urlHost + 'a-ogni-costo'
		this.linkUrl.next = urlBase + urlHost +'sai-cosa-fumi'
	},
	updated() {
		this.calculateVideoWidth()
	}
}
</script>

<style scoped>
	#phone-gif {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);;
	}
	#full-video-container {height: 100vh;}
	.inner-vid-conteiner {
		width: 100%;
		position: absolute;
		top:50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.inner-vid-wrap {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
	}
	.btn-cmd {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 20px;
	}
	.mt-btn-epilog {margin-top: 4%;}

	@media (max-width: 991.98px) {
		.btn {
			padding: .344rem 3rem;
		}
		.btn.game {
			font-size: .9rem;
		}
		.border-4-blk-new  p {
			font-size: 1rem !important;
		}
		.text-size-box-5 {
			font-size: 1.3rem !important;
		}
		.mt-btn-epilog {margin-top: 3%;}
	}
	@media (max-width: 767.98px) {
		.border-4-blk-new p {
			font-size: 0.94rem !important;
		}
		.border-4-blk-new.mx-epilogo {
			margin-left: 0;
			margin-right: 2%;
		}
		.border-4-blk-new.mx-epilogo p {font-size: .81rem !important;}
	}

	@media (max-width: 767.98px) {
		.py-btn {
			padding-top: .15rem;
			padding-bottom: .15rem;
		}
		.text-1 {font-size: 1rem;}
		.text-2 {font-size: .75rem;}
		.btn-cmd {bottom: 10px;}

		.label-answer {
			width: 11% !important;
			padding-top: 11% !important;
			margin-left: -18% !important;
		}

	}
	.question-container {
		padding-left: 11.6%;
		padding-right: 7%;
		margin-top: 10%;
	}
	.label-answer {
		width:9%;
		height: 0;
		padding-top: 8%;
		line-height: 1;
		border-radius: 100%;
		position: relative;
	}
	.label-answer-inner {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.my-button {
		margin-top: 2%;
		margin-bottom: 2%;
		border-width: 3px !important;
		padding: 0.25rem 1rem 0.25rem 2.3rem !important;
	}
	.mt-answers {margin-top: 3%;}
	.py-answers-box {
		padding-top: 5%;
		/*padding-bottom: 8%;*/
	}
	.mx-epilogo {
		margin-left: 1%;
		margin-right: 2%;
		overflow-y: auto;
	}
	.p-2-pr {
		padding: 1.5%;
	}
	.my-2x {
		margin-top: 2%;
		margin-bottom: 1.4%;
	}
	@media (max-width: 767.98px) {
		.my-button {
			margin-top: 0.6%;
			margin-bottom: 0.6%;
		}
		.mt-answers {
			margin-top: 0;
			padding-right: 8px;
		}
		.my-2x {margin-bottom: 0.4%;}
	}

	.btn {
		border-width: 4px;
		font-weight: 800;
		padding-top: .6rem;
		padding-bottom: .6rem;
		font-size: 1.5rem
	}
	@media (max-width: 991.98px) {
		.btn {
			padding: 0.25rem 3rem;
			font-size: 0.9rem
		}
	.counter {
		margin-top: 3.5%;
		line-height: 1;
	}
	}
	.counter {
		margin-top: 3.2%;
		line-height: 1;
	}
	.fade-enter-active/*, .fade-leave-active*/ {
		transition: opacity 0.9s;
	}
	.fade-enter/*, .fade-leave-to */ {
		opacity: 0;
	}
</style>
